import { RollCompetitionContentTabs } from '@/components/RollCompetition/Content/Tabs/props';
import { ModalsKey } from '@/enums/modalsKey';
import { useModalNavigation, useSearchParams } from '@starsoft/common/hooks';
import { useCallback } from 'react';

export function useRollCompetition() {
  const params = useSearchParams();
  const { navigateToModal } = useModalNavigation();

  const currentTab =
    (params.get('tab') as RollCompetitionContentTabs) ??
    RollCompetitionContentTabs.Information;

  const onTabChange = useCallback(
    (e: RollCompetitionContentTabs) => {
      navigateToModal(ModalsKey.RollCompetition, `?tab=${e}`);
    },
    [navigateToModal],
  );

  return {
    currentTab,
    onTabChange,
  };
}
